import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../contexts/LanguageContext';
import { useCart } from '../../contexts/CartContext';
import { 
  Bars3Icon,
} from '@heroicons/react/24/outline';
import SearchBar from '../SearchBar';
import MobileSearchModal from '../MobileSearchModal';
import MobileMenu from '../MobileMenu';
import CategoryNavigation from '../CategoryNavigation';
import './Header.css';
import Logo from '../Logo/logo';
import SearchIconHeader from './SerachIcon';
import CartTag from './CartTag';
import ToggleMenu from './toggleMenu';
import HeaderDesktopNav from './HeaderDesktopNav';
import LanguageSwitcherButton from './LanguageSwitcherButton';
import { useSelector } from 'react-redux';
import { getAllCategories, selectAllCategories } from '../../features/categories';
import { AppDispatch } from '../../features/store';
import { useDispatch } from 'react-redux';
const Header: React.FC = () => {
  // const { t } = useTranslation();
  const { isRTL } = useLanguage();
  const { openCart, getItemCount } = useCart();
  const dispatch:AppDispatch=useDispatch();
  const categories=useSelector(selectAllCategories);
  // Check if user is logged in
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
  const [isCategoryMenuOpen, setIsCategoryMenuOpen] = useState(false);
  
  useEffect(()=>{
    dispatch(getAllCategories());
  },[])

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleMobileSearch = () => {
    setIsMobileSearchOpen(!isMobileSearchOpen);
  };

  const toggleCategoryMenu = () => {
    setIsCategoryMenuOpen(!isCategoryMenuOpen);
  };

  const handleCategorySelect = (categoryId: string) => {
    // TODO: Navigate to category page or filter products
    console.log('Selected category:', categoryId);
  };

  return (
    <header className={`header ${isRTL ? 'rtl' : 'ltr'}`}>
      {/* Animated Neon Lines Background */}
      <div className="neon-lines-container">
        <div className="neon-line red line-1"></div>
        <div className="neon-line black line-2"></div>
        <div className="neon-line red line-3"></div>
        <div className="neon-line black line-4"></div>
        <div className="neon-line red line-5"></div>
        <div className="neon-line black line-6"></div>
      </div>

      {/* Main Header */}
      <div className="main-header">
        <div className="container">
          <div className="header-content">
            <Logo />
            <div className="search-section">
              <SearchBar />
            </div>
            <SearchIconHeader toggleMobileSearch={toggleMobileSearch} />
            <LanguageSwitcherButton />
            <CartTag openCart={openCart} getItemCount={getItemCount} />
            <ToggleMenu toggleMobileMenu={toggleMobileMenu} />
          </div>
        </div>
      </div>

      {/* Navigation */}
      <HeaderDesktopNav isMobileMenuOpen={isMobileMenuOpen} toggleCategoryMenu={toggleCategoryMenu} categories={categories} />

      {/* Mobile Search Modal */}
      <MobileSearchModal 
        isOpen={isMobileSearchOpen} 
        onClose={() => setIsMobileSearchOpen(false)} 
      />

      {/* Mobile Menu */}
      <MobileMenu
        isOpen={isMobileMenuOpen}
        categories={categories}
        onClose={() => setIsMobileMenuOpen(false)}
        onSearchOpen={() => setIsMobileSearchOpen(true)}
      />

      {/* Category Navigation */}
      <CategoryNavigation
        categories={categories}
        onCategorySelect={handleCategorySelect}
        isOpen={isCategoryMenuOpen}
        onToggle={() => setIsCategoryMenuOpen(false)}
      />
    </header>
  );
};

export default Header;
